import { Component, Input } from '@angular/core'
import { ToastrService } from 'ngx-toastr'
import { CommonModule } from '@angular/common'
import { ClientModel } from '../../../../client/client.model'
import { MemberModel } from '../../../../member-client/member.model'

@Component({
  selector: 'app-contact-client',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './contactClient.component.html',
  styleUrl: './contactClient.component.css',
})
export class ContactClientComponent {
  @Input() companyDetails: ClientModel | undefined
  @Input() memberDetails: MemberModel | undefined

  constructor() {
    
  }
}
